export default "__VITE_ASSET__CE8z1qfU__"